var _g, _path, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 399 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_295_12850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9739 59.7599L39.5709 96.7376C41.925 94.1782 44.9117 91.5126 48.9205 89.2994C54.7551 86.0775 62.5114 83.942 73.254 84.1338C89.5353 84.4242 96.1144 75.7008 97.89 72.7216L85.9692 34.7118C81.0831 39.1401 71.7414 45.3366 58.4237 44.3144C42.7232 43.1094 33.3348 53.0265 27.9739 59.7599ZM34.663 102.809L41.4893 124.575C42.0265 126.288 43.8503 127.241 45.563 126.704C47.2756 126.167 48.2286 124.343 47.6915 122.63L41.8711 104.072C44.3641 100.929 47.3839 97.5726 52.0624 94.9895C56.7523 92.3996 63.3515 90.458 73.1377 90.6328C94.9913 91.0226 102.863 77.4267 104.179 74.7583C104.687 73.7295 104.68 72.6507 104.402 71.763L91.0248 29.1108C90.0003 25.8441 85.9036 25.3202 83.8746 27.6102C81.0556 30.7925 72.4711 38.8734 58.9211 37.8334C45.1744 36.7784 35.4801 42.8207 29.0242 48.9317C28.9664 48.5477 28.8784 48.1633 28.7585 47.7812C27.5052 43.7849 23.2496 41.5614 19.2534 42.8147C15.2572 44.068 13.0336 48.3236 14.2869 52.3198C15.1922 55.2063 17.6637 57.1679 20.4726 57.5625L21.3949 60.5033C21.3951 60.504 21.3953 60.5047 21.3956 60.5055L34.6615 102.805C34.6621 102.806 34.6625 102.808 34.663 102.809Z",
    fill: "url(#paint0_linear_295_12850)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.509 35.4869V87.6552C162.564 85.316 167.474 83.0953 173.515 81.8674C182.307 80.0795 193.13 80.461 206.851 85.0349C227.647 91.9666 239.612 83.412 243.092 80.3005V26.6762C235.033 30.3958 220.537 34.5919 203.843 27.9139C184.162 20.0415 168.108 28.9976 158.509 35.4869ZM149.759 93.4769V124.185C149.759 126.601 151.718 128.56 154.134 128.56C156.55 128.56 158.509 126.601 158.509 124.185V98.0024C162.977 94.9702 168.208 91.875 175.258 90.4418C182.326 89.0045 191.584 89.169 204.084 93.3357C231.997 102.64 247.585 88.3476 250.35 85.4502C251.417 84.3331 251.842 82.9448 251.842 81.6924V21.5185C251.842 16.9098 246.791 14.5866 243.263 16.7107C238.36 19.6626 224.078 26.584 207.093 19.7897C189.86 12.897 174.974 16.7528 164.22 22.0016C164.301 21.4851 164.342 20.9558 164.342 20.4167C164.342 14.7788 159.772 10.2084 154.134 10.2084C148.496 10.2084 143.926 14.7788 143.926 20.4167C143.926 24.489 146.31 28.0043 149.759 29.6426V33.7914C149.759 33.7925 149.759 33.7935 149.759 33.7945V93.4705C149.759 93.4728 149.759 93.4745 149.759 93.4769Z",
    fill: "url(#paint1_linear_295_12850)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_295_12850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.565 42.7378L301.112 80.0548C304.481 79.1941 308.438 78.5895 313.005 78.9216C319.653 79.4045 327.318 81.8462 336.217 87.8676C349.703 96.9932 359.976 93.2716 363.089 91.7434L373.835 53.3849C367.324 54.4305 356.115 54.5273 345.511 46.4051C333.01 36.8299 319.732 40.0193 311.565 42.7378ZM293.686 82.4657L287.532 104.432C287.048 106.16 288.057 107.954 289.785 108.438C291.514 108.922 293.307 107.913 293.791 106.185L299.038 87.4563C302.842 86.1827 307.204 85.0169 312.534 85.4044C317.877 85.7925 324.467 87.7655 332.574 93.2508C350.676 105.5 364.691 98.3999 367.249 96.8814C368.236 96.296 368.819 95.3882 369.07 94.4924L381.128 51.4488C382.051 48.1521 378.904 45.4781 375.954 46.2904C371.855 47.4195 360.252 49.5086 349.464 41.2449C338.518 32.8613 327.097 32.6364 318.353 34.2359C318.514 33.8826 318.65 33.5123 318.758 33.1267C319.888 29.0938 317.534 24.9087 313.501 23.7789C309.469 22.6491 305.283 25.0026 304.154 29.0355C303.338 31.9485 304.339 34.9409 306.478 36.8039L305.646 39.7716C305.646 39.7724 305.646 39.7731 305.646 39.7738L293.687 82.4612C293.687 82.4628 293.686 82.4641 293.686 82.4657Z",
    fill: "url(#paint2_linear_295_12850)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_295_12850",
    x1: -94.2395,
    y1: -531.509,
    x2: 59.2638,
    y2: -566.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_295_12850",
    x1: 239.715,
    y1: -773.209,
    x2: 451.003,
    y2: -756.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_295_12850",
    x1: 531.707,
    y1: -519.465,
    x2: 679.475,
    y2: -465.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_295_12850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white",
    transform: "translate(0.445312 40.7659) rotate(-17.4126)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_295_12850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white",
    transform: "translate(298.855 11.801) rotate(15.6496)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlags);
export default __webpack_public_path__ + "static/media/flags.b5ed072e7793449eed1130e756d404e6.svg";
export { ForwardRef as ReactComponent };